module.exports = __webpack_public_path__ + "static/media/HelveticaNeueCyr-Light.2650ce10.woff2";